<template>
	<div class="avatar-wrapper"><img :src="src" class="img" /> {{ title }}</div>
</template>

<script>
export default {
	name: "j-avatar",
	props: {
		src: {
			type: String,
			required: true,
			default: ""
		},
		title: {
			type: String,
			required: false,
			default: ""
		}
	}
}
</script>

<style scoped>
@import "../../assets/css/tokens.css";

.avatar-wrapper {
	display: flex;
	justify-content: flex-start;
	align-items: center;
	width: 32px;
	height: 32px;
}

.img {
	display: block;
	width: 100%;
	height: 100%;
	object-fit: contain;
	margin-right: var(--spacing2);
	border-radius: 100000px;
}

.avatar-wrapper.small {
	width: 24px;
	height: 24px;
}

.avatar-wrapper.large {
	width: 48px;
	height: 48px;
}

/* Variants */
/* Pic is on the right side */
.avatar-wrapper.right > img {
	order: 2;
	margin: 0;
	margin-left: var(--spacing2);
}
</style>
